<template>
  <div>
    <v-layout wrap>
      <v-snackbar
        v-model="dialog.snackbar"
        top
        right
        color="#ff64ad">
        <span class="body-1 font-weight-light white--text"
          v-html="message.success">
        </span>

        <template v-slot:action="{ attrs }">
          <v-btn
            class="body-1 font-weight-bold text-capitalize"
            color="white"
            icon
            v-bind="attrs"
            @click="dialog.snackbar = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      <v-dialog v-model="dialog.form"
        @keydown.esc="dialog.form = false"
        :fullscreen="dialog.fullscreen"
        width="500"
        persistent
        scrollable>
        <v-card 
          :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
          class="pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Update Status
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.form = false; dialog.fullscreen = false;"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>
          
          <v-divider class="mx-4 mt-3 mb-2"/>

          <v-card-text class="body-1 font-weight-light text-first mt-3">
            Apakah Anda yakin mengubah status ajuan pengiriman dari {{ menu[selected.menu].text }} menjadi 
            {{ 
              menu[selected.menu].text === 'REQUEST' ? 'DIPROSES' :
              menu[selected.menu].text === 'DIKOREKSI' ? 'DIPROSES' :
              menu[selected.menu].text === 'DIPROSES' ? 'DISORTIR' :
              menu[selected.menu].text === 'DISORTIR' ? 'DITOLAK' : 'DITOLAK' 
            }}?
          </v-card-text>

          <v-alert v-if="message.error.length > 0"
            class="mx-6"
            type="error" 
            dense
            text 
            prominent>
            {{ message.error }}
          </v-alert>

          <v-divider class="mx-4 mb-3 mt-0"/>

          <v-card-actions>
            <v-spacer/>

            <v-btn
              color="#ff64ad"
              elevation="0"
              class="body-2 font-weight-bold text-capitalize white--text"
              :disabled="process.form"
              :loading="process.form"
              @click="save()">
              <v-icon small class="mr-1">mdi-check-bold</v-icon>
              Ya, Simpan
            </v-btn>

            <v-btn
              outlined
              class="body-2 font-weight-bold text-capitalize red--text"
              :disabled="process.form"
              @click="dialog.form = false; dialog.fullscreen = false;">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
              Batal
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-flex>
        <section>
          <v-tabs
            v-model="selected.menu"
            background-color="transparent"
            color="#ff64ad"
            slider-size="5"
            show-arrows
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            dense
            grow
            class="d-flex justify-start tabs-stream">
            <v-tab
              v-for="(item, index) in menu"
              :key="index"
              class="px-0 mr-4 d-flex align-center">
              <v-avatar
                tile
                size="20">
                <v-img 
                  contain
                  :src="item.icon">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        size="20"
                        color="#ff64ad">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-avatar>

              <span 
                class="body-2 text-capitalize ml-2" 
                :class="selected.menu === index ? 'font-weight-bold' : 'text-third'">
                {{ item.text }}
              </span>
            </v-tab>
          </v-tabs>
          
          <v-card 
            flat 
            style="border: 1px solid #E0E0E0;">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="8" class="d-flex align-center">
                  <!-- DETAIL -->
                  <div class="mr-3" v-if="selected.row.length === 1">
                    <v-btn
                      :to="`pos/${selected.row[0].id}`"
                      elevation="0"
                      style="background: #e0e0e0;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center text-second">
                      <v-icon size="18">mdi-information-outline</v-icon>

                      <span class="ml-1">
                        Detail
                      </span>
                    </v-btn>
                  </div>

                  <!-- PROSES -->
                  <div class="mr-3" v-if="selected.row.length > 0 && selected.menu === 2">
                    <v-btn
                      @click="dialog.form = true; reset();"
                      elevation="0"
                      style="background: #2196f333;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text">
                      <v-icon size="18">mdi-list-status</v-icon>

                      <span class="ml-1">
                        Ubah Status
                      </span>
                    </v-btn>
                  </div>
                </v-col>

                <v-col cols="12" md="4" class="d-flex align-center justify-end">
                  <v-text-field 
                    class="mr-3"
                    dense
                    single-line
                    hide-details
                    color="#ff64ad"
                    placeholder="Cari . . ."
                    append-icon="mdi-magnify"
                    clearable
                    v-model="search"
                    v-uppercase
                    @click:clear="search = ''; fetch();"
                    v-on:keyup.enter="fetch()">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              v-model="selected.row"
              ref="table-grid"
              class="table-grid"
              :height="`calc(100vh - ${pagination.total_data > 0 ? '340px' : '268px'})`"
              :show-select="checkbox"
              :single-select="false"
              :loading="process.load"
              loading-text="Sedang memuat data . . ."
              loader-height="5"
              no-results-text="Belum ada data"
              :options.sync="options"
              :headers="configHeaders"
              :items="list"
              :items-per-page="100"
              item-key="id"
              @click:row="rowClick"
              @toggle-select-all="handleToggleAll($event)"
              hide-default-footer>
              <template
                v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                v-slot:[`item.${header.value}`]="{ value, index }">
                <div
                  v-bind:key="header.value">
                  <div v-if="header.format !== 'total'">
                    {{ rowFormat(header.format, value) }} 
                  </div>

                  <div v-if="header.format === 'total'"
                    class="d-flex align-center">
                    <div
                      v-for="(item, sub_index) in list[index].delivery_item"
                      :key="sub_index">
                      <span
                        class="mr-1">
                        {{ item.delivery_item_layanan_kode }}{{ sub_index < list[index].delivery_item.length - 1 ? ',' : '' }}
                      </span>
                    </div>
                  </div>
                </div>
              </template>
              
              <template v-slot:[`item.index`]="{ index }">
                {{ lastIndex + index }}
              </template>

              <v-progress-linear 
                v-show="process.load" 
                slot="progress" 
                color="white" 
                indeterminate>
              </v-progress-linear>
            </v-data-table>

            <pagination v-if="pagination.total_data > 0"
              @changePage="fetch($event)" 
              @reloadPage="fetch($event)" 
              :model="pagination"/>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: true,

        dialog: {
          snackbar: false,
          fullscreen: false,

          form: false
        },

        search: '',

        selected: {
          row: [],
          freeze: [],

          menu: 0
        },

        menu: [
          {
            text: 'REQUEST',
            icon: require('@/assets/image/pos_request.png')
          },
          {
            text: 'DIKOREKSI',
            icon: require('@/assets/image/pos_approval.png')
          },
          {
            text: 'DIPROSES',
            icon: require('@/assets/image/pos_dikemas.png')
          },
          {
            text: 'DISORTIR',
            icon: require('@/assets/image/pos_sortir.png')
          },
          {
            text: 'DITOLAK',
            icon: require('@/assets/image/pos_tolak.png')
          }
        ],

        options: {},
        headers: [],
        list: [],

        limit: 20,
        pagination: {},
        lastIndex: 0,

        form: {
          delivery: []
        },

        process: {
          load: false,

          form: false
        },

        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      },

      'selected.menu': function() {
        this.fetch()
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value.split('.')[0]
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          },00`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].title)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'total') {
          data = value
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }
        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'DESC' : 'ASC',
          search: this.search,

          delivery_status: this.menu[this.selected.menu].text
        }

        this.selected.row = []

        await get('delivery', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Kode',
                width: '200px',
                value: 'delivery_kode',
                freeze: true,
                hide: false
              },
              {
                text: 'Penerima',
                width: '300px',
                value: 'delivery_receiver_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Telepon',
                width: '200px',
                value: 'delivery_receiver_phone',
                freeze: false,
                hide: false
              },
              {
                text: 'Produk',
                width: '200px',
                value: 'delivery_item',
                freeze: false,
                hide: false,
                format: 'total'
              },
              {
                text: 'Group',
                width: '200px',
                value: 'delivery_proses_kode',
                freeze: true,
                hide: false
              },
              {
                text: 'Resi',
                width: '200px',
                value: 'delivery_resi',
                freeze: false,
                hide: false
              },
              {
                text: 'Status',
                width: '200px',
                value: 'delivery_status',
                freeze: false,
                hide: false
              },
              {
                text: 'Tanggal',
                width: '200px',
                value: 'delivery_create_datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              }
            ]
            
            this.list = res.data
            this.pagination = res.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: ${this.set_color};
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: ${this.set_color};
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()

        let data = this.selected.row

        this.form.delivery = []

        data.forEach(item => {
          this.form.delivery.push({
            delivery_kode: item.delivery_kode,
            status: this.menu[this.selected.menu].text === 'REQUEST' ? 'DIPROSES' :
                    this.menu[this.selected.menu].text === 'DIKOREKSI' ? 'DIPROSES' :
                    this.menu[this.selected.menu].text === 'DIPROSES' ? 'DISORTIR' :
                    this.menu[this.selected.menu].text === 'DISORTIR' ? 'DITOLAK' : 'DITOLAK',
            note: ''
          })
        })

        this.process.form = false

        this.message.error = ''
      },

      async save() {
        this.message.error = ''

        this.process.form = true

        // SAVE TO REST API
        await post(`delivery/updateStatus`, {
          data: this.form
        })
        .then((response) => {
          let res = response.data

          this.process.form = false

          if (res.code === 200) {
            this.dialog.form = false

            this.dialog.snackbar = true
            this.message.success = res.message

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
  .table-grid table thead > tr > th, .table-grid table tbody > tr > td {
    position: sticky;
    position: -webkit-sticky;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  .table-grid table > thead > tr > th:nth-child(1) {
    left: 0; 
    z-index: 5;
    background: #ff64ad;
  }

  .table-grid table > tbody > tr > td:nth-child(1) {
    left: 0; 
    z-index: 1;
  }

  .table-grid table > tbody > tr:nth-of-type(even) .text-start, table > tbody > tr:nth-of-type(even) .text-center, table > tbody > tr:nth-of-type(even) .text-end {
    background: #fafafa;
  }

  .table-grid table > tbody > tr:nth-of-type(odd) .text-start, table > tbody > tr:nth-of-type(odd) .text-center, table > tbody > tr:nth-of-type(odd) .text-end {
    background: white;
  }
</style>